module.exports = __webpack_public_path__ + "img/icon_06.b1d5f7c.png";